/**
 * Activity Slide Renderer
 * Routes and renders all activity slide types
 */

import type { ActivitySlideProps } from '../types';
import MultipleChoiceSlide from './MultipleChoiceSlide';
import TrueFalseSlide from './TrueFalseSlide';
import OpenEndedSlide from './OpenEndedSlide';
import PollSlide from './PollSlide';
import FillBlanksSlide from './FillBlanksSlide';
import TimeToClimb from './TimeToClimb';
import MatchingPairs from './MatchingPairs';
import DrawIt from './DrawIt';
import CollaborateBoard from './CollaborateBoard';
import WordCloud from './WordCloud';
import DragDrop from './DragDrop';
import Sequencing from './Sequencing';
import Quiz from './Quiz';
import LabelDiagram from './LabelDiagram';

/**
 * Routes to the correct activity slide component based on slide type
 */
export default function ActivitySlideRenderer(props: ActivitySlideProps) {
  const { slide, className = '' } = props;
  
  // Default viewMode to 'student' if not provided for backward compatibility
  const propsWithDefaults = { ...props, viewMode: props.viewMode || 'student' };

  switch (slide.type) {
    case 'multiple_choice':
      return <MultipleChoiceSlide {...propsWithDefaults} className={className} />;
    case 'true_false':
      return <TrueFalseSlide {...propsWithDefaults} className={className} />;
    case 'open_ended':
      return <OpenEndedSlide {...propsWithDefaults} className={className} />;
    case 'poll':
      return <PollSlide {...propsWithDefaults} className={className} />;
    case 'fill_blanks':
      return <FillBlanksSlide {...propsWithDefaults} className={className} />;
    case 'time_to_climb':
      return <TimeToClimb {...propsWithDefaults} className={className} />;
    case 'matching_pairs':
      return <MatchingPairs {...propsWithDefaults} className={className} />;
    case 'draw_it':
      return <DrawIt {...propsWithDefaults} className={className} />;
    case 'collaborate_board':
      return <CollaborateBoard {...propsWithDefaults} className={className} />;
    case 'word_cloud':
      return <WordCloud {...propsWithDefaults} className={className} />;
    case 'label_diagram':
      return <LabelDiagram {...propsWithDefaults} className={className} />;
    case 'drag_drop':
      return <DragDrop {...propsWithDefaults} className={className} />;
    case 'sequencing':
      return <Sequencing {...propsWithDefaults} className={className} />;
    case 'quiz':
      return <Quiz {...propsWithDefaults} className={className} />;
    default:
      return (
        <div className={`text-center text-muted-foreground ${className}`}>
          Activity type "{slide.type}" not yet implemented
        </div>
      );
  }
}
